export default __webpack_public_path__ + "static/media/LAS0750.34I-37174_-21988_0.4ae2155b.jpg";